var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from "react";
import { Permission } from "ee-nestjs-interfaces";
import { Auth0Fetcher, OnOffRadio, HelpTooltip, StaticTable, StyledButton, TextInput, } from "ee-react-components";
import { useAuth0 } from "@auth0/auth0-react";
import useSWR from "swr";
import { process } from "../../Process";
import { GetDisplayPrice, NumberLocaleStringStyle } from "ee-utils";
import { usePermissions } from "../../PermissionsContext";
var IdleFee = function (_a) {
    var title = _a.title, helpText = _a.helpText, detail = _a.detail, disabled = _a.disabled, minimumGracePeriod = _a.minimumGracePeriod, idleFeeEnabled = _a.idleFeeEnabled, idleFeeAmount = _a.idleFeeAmount, idleFeeGracePeriod = _a.idleFeeGracePeriod, idleFeeMaxAmount = _a.idleFeeMaxAmount, setIdleFeeAmount = _a.setIdleFeeAmount, setIdleFeeEnabled = _a.setIdleFeeEnabled, setIdleFeeGracePeriod = _a.setIdleFeeGracePeriod, setIdleFeeMaxAmount = _a.setIdleFeeMaxAmount;
    return (React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
        React.createElement("div", { className: "flex flex-row gap-x-4 items-center" },
            React.createElement("label", { className: "text-black-400 font-N8p5" }, title),
            React.createElement(HelpTooltip, { text: helpText })),
        React.createElement("div", { className: "flex flex-row gap-x-[16px] items-center" },
            React.createElement(OnOffRadio, { on: idleFeeEnabled !== null && idleFeeEnabled !== void 0 ? idleFeeEnabled : false, setOn: setIdleFeeEnabled, disabled: disabled }),
            React.createElement("div", { className: "flex flex-row gap-x-[16px] items-center ".concat(!idleFeeEnabled ? "opacity-25" : "") },
                React.createElement("label", { className: "font-N8 text-white" }, detail),
                React.createElement(TextInput, { placeholder: "".concat(idleFeeGracePeriod !== null && idleFeeGracePeriod !== void 0 ? idleFeeGracePeriod : "60"), value: "".concat(idleFeeGracePeriod !== null && idleFeeGracePeriod !== void 0 ? idleFeeGracePeriod : "60"), required: true, type: "number", step: "1", min: minimumGracePeriod, className: "w-[120px]", onChange: function (e) { return setIdleFeeGracePeriod(e.target.value); }, disabled: !idleFeeEnabled || disabled }),
                React.createElement("label", { className: "font-N8 text-white" }, "minutes:"),
                React.createElement("span", { className: "before:text-black-600 relative before:content-['$'] before:absolute before:pl-[8px] before:translate-y-[-50%] before:top-[50%] after:content-['/minute'] after:absolute after:translate-y-[-50%] after:top-[50%] after:right-[8px] after:text-black-600" },
                    React.createElement(TextInput, { placeholder: idleFeeAmount, value: idleFeeAmount, required: true, type: "number", step: ".01", min: ".01", max: "1", pattern: "^\\d+(\\.)\\d{2}$", className: "!pr-[48px]", disabled: !idleFeeEnabled || disabled, onChange: function (e) { return setIdleFeeAmount(e.target.value); } })),
                React.createElement("label", { className: "font-N8 text-white" }, "with a max of"),
                React.createElement("span", { className: "before:text-black-600 relative before:content-['$'] before:absolute before:pl-[8px] before:translate-y-[-50%] before:top-[50%]" },
                    React.createElement(TextInput, { placeholder: idleFeeMaxAmount, value: idleFeeMaxAmount, required: true, type: "number", step: ".01", min: "1", className: "w-[120px]", disabled: !idleFeeEnabled || disabled, onChange: function (e) { return setIdleFeeMaxAmount(e.target.value); } }))))));
};
var MemberTierRow = function (_a) {
    var tierCode = _a.tierCode, rate = _a.rate, disabled = _a.disabled, setTierCode = _a.setTierCode, setRate = _a.setRate, onRemove = _a.onRemove;
    return (React.createElement("div", { className: "flex flex-row gap-x-[16px] items-center" },
        React.createElement(TextInput, { placeholder: "Tier code", value: tierCode, required: true, type: "text", className: "w-[160px]", onChange: function (e) { return setTierCode(e.target.value); }, disabled: disabled }),
        React.createElement("span", { className: "before:text-black-600 relative before:content-['$'] before:absolute before:pl-[8px] before:translate-y-[-50%] before:top-[50%] after:content-['/kWh'] after:absolute after:translate-y-[-50%] after:top-[50%] after:right-[8px] after:text-black-600" },
            React.createElement(TextInput, { placeholder: rate, value: rate, required: true, type: "number", step: ".01", min: ".01", max: "9.99", pattern: "^\\d+(\\.)\\d{2}$", className: "!pr-[48px]", onChange: function (e) { return setRate(e.target.value); }, disabled: disabled })),
        React.createElement(StyledButton, { text: "REMOVE", onClick: onRemove, disabled: disabled })));
};
export var Pricing = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var details = _a.details, tieredPricingEnabled = _a.tieredPricingEnabled;
    var _j = useAuth0(), isAuthenticated = _j.isAuthenticated, isLoading = _j.isLoading, getAccessTokenSilently = _j.getAccessTokenSilently;
    var permissions = usePermissions();
    var hasPricingWritePermission = permissions.hasPermissionForSite(Permission.WRITE_PRICING, details.id);
    var requestUrl = "".concat(process.env.CORE_SVC_URL, "/pricing/current/").concat(details.id);
    var newPricing = useSWR(isLoading || !isAuthenticated ? null : [requestUrl, getAccessTokenSilently], Auth0Fetcher).data;
    var _k = useState(), storedPricing = _k[0], setStoredPricing = _k[1];
    // useSWR only hands back a new `newPricing` reference when a fetch/revalidation actually
    // completes, so this ref lets us skip the (now potentially large, with membershipPricing)
    // JSON.stringify comparison on renders where nothing was refetched — e.g. every keystroke in
    // this form — while still doing a real content comparison whenever new data does arrive.
    var lastSeenPricing = useRef(undefined);
    if (lastSeenPricing.current !== newPricing) {
        lastSeenPricing.current = newPricing;
        if (JSON.stringify(storedPricing) != JSON.stringify(newPricing)) {
            setStoredPricing(newPricing);
        }
    }
    var isPricingCurrent = (storedPricing === null || storedPricing === void 0 ? void 0 : storedPricing.freemode) == undefined;
    var pricing = isPricingCurrent
        ? storedPricing
        : (_b = storedPricing === null || storedPricing === void 0 ? void 0 : storedPricing.freemode) === null || _b === void 0 ? void 0 : _b.previousPricingModel;
    var formRef = useRef(null);
    var _l = useState(GetDisplayPrice((_d = (_c = pricing === null || pricing === void 0 ? void 0 : pricing.pricePerKwh) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d.amount, (_g = (_f = (_e = pricing === null || pricing === void 0 ? void 0 : pricing.pricePerKwh) === null || _e === void 0 ? void 0 : _e.amount) === null || _f === void 0 ? void 0 : _f.precision) !== null && _g !== void 0 ? _g : 2)), pricePerKwh = _l[0], setPricePerKwh = _l[1];
    var _m = useState(!isPricingCurrent), freeMode = _m[0], setFreeMode = _m[1];
    var _o = useState(""), changeDescription = _o[0], setChangeDescription = _o[1];
    var _p = useState(false), idleFeesAfterChargingStartsEnabled = _p[0], setIdleFeesAfterChargingStartsEnabled = _p[1];
    var _q = useState("0.50"), idleFeeAfterChargingStarts = _q[0], setIdleFeeAfterChargingStarts = _q[1];
    var _r = useState("60"), idleFeeAfterChargingStartsGracePeriod = _r[0], setIdleFeeAfterChargingStartsGracePeriod = _r[1];
    var _s = useState("50.00"), idleFeeAfterChargingStartsMaxAmount = _s[0], setIdleFeeAfterChargingStartsMaxAmount = _s[1];
    var _t = useState(false), idleFeesAfterChargingEndsEnabled = _t[0], setIdleFeesAfterChargingEndsEnabled = _t[1];
    var _u = useState("0.50"), idleFeeAfterChargingEnds = _u[0], setIdleFeeAfterChargingEnds = _u[1];
    var _v = useState("60"), idleFeeAfterChargingEndsGracePeriod = _v[0], setIdleFeeAfterChargingEndsGracePeriod = _v[1];
    var _w = useState("50.00"), idleFeeAfterChargingEndsMaxAmount = _w[0], setIdleFeeAfterChargingEndsMaxAmount = _w[1];
    var _x = useState(false), memberPricingEnabled = _x[0], setMemberPricingEnabled = _x[1];
    var _y = useState("0.00"), defaultMemberRate = _y[0], setDefaultMemberRate = _y[1];
    var _z = useState([]), tierOverrides = _z[0], setTierOverrides = _z[1];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
        if (pricing != null) {
            setPricePerKwh(GetDisplayPrice((_b = (_a = pricing.pricePerKwh) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.amount, (_e = (_d = (_c = pricing.pricePerKwh) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d.precision) !== null && _e !== void 0 ? _e : 2));
            setFreeMode(!isPricingCurrent);
            setIdleFeesAfterChargingStartsEnabled(pricing.idleFeesAfterChargingStarts != null);
            if (pricing.idleFeesAfterChargingStarts != null) {
                setIdleFeeAfterChargingStarts(GetDisplayPrice((_f = pricing.idleFeesAfterChargingStarts.amountPerMinute) === null || _f === void 0 ? void 0 : _f.amount, (_g = pricing.idleFeesAfterChargingStarts.amountPerMinute) === null || _g === void 0 ? void 0 : _g.precision));
                setIdleFeeAfterChargingStartsGracePeriod("".concat(pricing.idleFeesAfterChargingStarts.gracePeriodMinutes));
                if (pricing.idleFeesAfterChargingStarts.maxAmount) {
                    setIdleFeeAfterChargingStartsMaxAmount(GetDisplayPrice((_h = pricing.idleFeesAfterChargingStarts.maxAmount) === null || _h === void 0 ? void 0 : _h.amount, (_j = pricing.idleFeesAfterChargingStarts.maxAmount) === null || _j === void 0 ? void 0 : _j.precision));
                }
            }
            setIdleFeesAfterChargingEndsEnabled(pricing.idleFeesAfterChargingEnds != null);
            if (pricing.idleFeesAfterChargingEnds != null) {
                setIdleFeeAfterChargingEnds(GetDisplayPrice((_k = pricing.idleFeesAfterChargingEnds.amountPerMinute) === null || _k === void 0 ? void 0 : _k.amount, (_l = pricing.idleFeesAfterChargingEnds.amountPerMinute) === null || _l === void 0 ? void 0 : _l.precision));
                setIdleFeeAfterChargingEndsGracePeriod("".concat(pricing.idleFeesAfterChargingEnds.gracePeriodMinutes));
                if (pricing.idleFeesAfterChargingEnds.maxAmount) {
                    setIdleFeeAfterChargingEndsMaxAmount(GetDisplayPrice((_m = pricing.idleFeesAfterChargingEnds.maxAmount) === null || _m === void 0 ? void 0 : _m.amount, (_o = pricing.idleFeesAfterChargingEnds.maxAmount) === null || _o === void 0 ? void 0 : _o.precision));
                }
            }
            var membershipPricing = pricing.membershipPricing;
            setMemberPricingEnabled(membershipPricing != null);
            if (membershipPricing != null) {
                var defaultModel = membershipPricing.defaultMembershipPricingModel;
                setDefaultMemberRate(GetDisplayPrice((_q = (_p = defaultModel === null || defaultModel === void 0 ? void 0 : defaultModel.pricePerKwh) === null || _p === void 0 ? void 0 : _p.amount) === null || _q === void 0 ? void 0 : _q.amount, (_t = (_s = (_r = defaultModel === null || defaultModel === void 0 ? void 0 : defaultModel.pricePerKwh) === null || _r === void 0 ? void 0 : _r.amount) === null || _s === void 0 ? void 0 : _s.precision) !== null && _t !== void 0 ? _t : 2));
                setTierOverrides(Object.entries((_u = membershipPricing.tierPricingModels) !== null && _u !== void 0 ? _u : {}).map(function (_a) {
                    var _b, _c, _d, _e, _f;
                    var tierCode = _a[0], tierModel = _a[1];
                    return ({
                        tierCode: tierCode,
                        rate: GetDisplayPrice((_c = (_b = tierModel.pricePerKwh) === null || _b === void 0 ? void 0 : _b.amount) === null || _c === void 0 ? void 0 : _c.amount, (_f = (_e = (_d = tierModel.pricePerKwh) === null || _d === void 0 ? void 0 : _d.amount) === null || _e === void 0 ? void 0 : _e.precision) !== null && _f !== void 0 ? _f : 2),
                    });
                }));
            }
        }
    }, [pricing, isPricingCurrent]);
    var buildPricePerKwhModel = function (rate) {
        var amount = Math.round(parseFloat(rate) * 100);
        if (isNaN(amount)) {
            return undefined;
        }
        return {
            amount: {
                amount: amount,
                precision: 2,
                currencyCode: "USD",
            },
        };
    };
    var onPriceSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var freemodeModel, pricePerKwhModel, convertInputsToIdleFee, model, buildMemberModel_1, update, accessToken, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    freemodeModel = undefined;
                    pricePerKwhModel = undefined;
                    if (freeMode) {
                        freemodeModel = {
                            previousPricingModel: pricing,
                        };
                    }
                    else {
                        pricePerKwhModel = buildPricePerKwhModel(pricePerKwh);
                        if (pricePerKwhModel == undefined) {
                            return [2 /*return*/];
                        }
                    }
                    convertInputsToIdleFee = function (enabled, amount, gracePeriodMinutes, maxAmount) {
                        var parsedAmount = Math.round(parseFloat(amount) * 100);
                        if (isNaN(parsedAmount)) {
                            return;
                        }
                        var parsedMaxAmount = Math.round(parseFloat(maxAmount) * 100);
                        if (isNaN(parsedMaxAmount)) {
                            return;
                        }
                        var gracePeriodParsed = Math.round(parseFloat(gracePeriodMinutes));
                        if (isNaN(gracePeriodParsed)) {
                            return;
                        }
                        return enabled
                            ? {
                                amountPerMinute: {
                                    amount: parsedAmount,
                                    precision: 2,
                                    currencyCode: "USD",
                                },
                                gracePeriodMinutes: gracePeriodParsed,
                                maxAmount: {
                                    amount: parsedMaxAmount,
                                    precision: 2,
                                    currencyCode: "USD",
                                },
                            }
                            : undefined;
                    };
                    model = {
                        freemode: freemodeModel,
                        pricePerKwh: pricePerKwhModel,
                        surcharges: [],
                        idleFeesAfterChargingEnds: !freeMode
                            ? convertInputsToIdleFee(idleFeesAfterChargingEndsEnabled, idleFeeAfterChargingEnds, idleFeeAfterChargingEndsGracePeriod, idleFeeAfterChargingEndsMaxAmount)
                            : undefined,
                        idleFeesAfterChargingStarts: !freeMode
                            ? convertInputsToIdleFee(idleFeesAfterChargingStartsEnabled, idleFeeAfterChargingStarts, idleFeeAfterChargingStartsGracePeriod, idleFeeAfterChargingStartsMaxAmount)
                            : undefined,
                    };
                    if (tieredPricingEnabled && memberPricingEnabled && !freeMode) {
                        buildMemberModel_1 = function (rate) { return ({
                            pricePerKwh: buildPricePerKwhModel(rate),
                            idleFeesAfterChargingStarts: model.idleFeesAfterChargingStarts,
                            idleFeesAfterChargingEnds: model.idleFeesAfterChargingEnds,
                            surcharges: [],
                        }); };
                        model.membershipPricing = {
                            defaultMembershipPricingModel: buildMemberModel_1(defaultMemberRate),
                            tierPricingModels: Object.fromEntries(tierOverrides.map(function (t) { return [t.tierCode, buildMemberModel_1(t.rate)]; })),
                        };
                    }
                    update = {
                        model: model,
                        changeDescription: changeDescription,
                    };
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        })];
                case 1:
                    accessToken = _a.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.CORE_SVC_URL, "/pricing/current/").concat(details.id), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify(update),
                        })];
                case 2:
                    res = _a.sent();
                    if (!res.ok) {
                        console.log("Error submitting price: ", res.statusText);
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var validateAndSubmitPricing = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tierCodes, childInputs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!formRef.current) {
                        return [2 /*return*/];
                    }
                    if (!formRef.current.checkValidity()) {
                        console.log("Skipping submit as form is invalid.");
                        return [2 /*return*/];
                    }
                    if (tieredPricingEnabled && memberPricingEnabled && !freeMode) {
                        tierCodes = tierOverrides.map(function (t) { return t.tierCode.trim(); });
                        if (tierCodes.some(function (code) { return code.length == 0; })) {
                            console.log("Skipping submit: tier codes cannot be empty.");
                            return [2 /*return*/];
                        }
                        if (new Set(tierCodes).size != tierCodes.length) {
                            console.log("Skipping submit: tier codes must be unique.");
                            return [2 /*return*/];
                        }
                    }
                    childInputs = formRef.current.querySelectorAll("input");
                    return [4 /*yield*/, onPriceSubmit()];
                case 1:
                    _a.sent();
                    childInputs.forEach(function (i) {
                        i.value = "";
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    var isCalifornia = ((_h = details.state) === null || _h === void 0 ? void 0 : _h.toLocaleLowerCase()) == "california";
    return (React.createElement(React.Fragment, null,
        !hasPricingWritePermission && (React.createElement("div", { className: "flex flex-col gap-y-[32px] mb-8" }, "You do not have permission to edit pricing.")),
        React.createElement("form", { className: "flex flex-col gap-y-[32px]", ref: formRef, onSubmit: function (e) { return e.preventDefault(); } },
            React.createElement("label", { className: "font-N6 text-white" }, "Free Mode"),
            React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                React.createElement("label", { className: "text-black-400 font-N8p5" }, "ENABLE FREE MODE"),
                React.createElement(OnOffRadio, { on: freeMode, setOn: setFreeMode, disabled: !hasPricingWritePermission })),
            React.createElement("div", { className: "flex flex-col gap-y-[32px] ".concat(freeMode ? "opacity-25" : "") },
                React.createElement("label", { className: "font-N6 text-white" }, "Pricing"),
                React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                    React.createElement("label", { className: "text-black-400 font-N8p5" }, "CURRENT PRICE"),
                    React.createElement("div", { className: "flex flex-row gap-x-[32px]" },
                        React.createElement("span", { className: "before:text-black-600 relative before:content-['$'] before:absolute before:pl-[8px] before:translate-y-[-50%] before:top-[50%] after:content-['/kWh'] after:absolute after:translate-y-[-50%] after:top-[50%] after:right-[8px] after:text-black-600" },
                            React.createElement(TextInput, { placeholder: pricePerKwh, value: pricePerKwh, required: !freeMode, type: "number", step: ".01", min: ".01", max: "9.99", pattern: "^\\d+(\\.)\\d{2}$", className: "!pr-[48px]", onChange: function (e) { return setPricePerKwh(e.target.value); }, disabled: freeMode || !hasPricingWritePermission }))))),
            React.createElement("div", { className: "flex flex-col gap-y-[32px] ".concat(freeMode ? "opacity-25" : "") }, !isCalifornia && (React.createElement(React.Fragment, null,
                React.createElement("label", { className: "font-N6 text-white" }, "Idle Fees"),
                React.createElement(IdleFee, { title: "IDLE FEES FOR LONG SESSIONS", detail: "After charging has been ongoing for", disabled: freeMode || !hasPricingWritePermission, minimumGracePeriod: "30", idleFeeEnabled: idleFeesAfterChargingStartsEnabled, idleFeeAmount: idleFeeAfterChargingStarts, idleFeeGracePeriod: idleFeeAfterChargingStartsGracePeriod, idleFeeMaxAmount: idleFeeAfterChargingStartsMaxAmount, helpText: "These fees begin accruing after a customer has been actively charging for longer than the specified time. Use this to discourage long charging sessions. Note that this fee will only apply while the charger is actively charging a car.", setIdleFeeAmount: setIdleFeeAfterChargingStarts, setIdleFeeEnabled: setIdleFeesAfterChargingStartsEnabled, setIdleFeeGracePeriod: setIdleFeeAfterChargingStartsGracePeriod, setIdleFeeMaxAmount: setIdleFeeAfterChargingStartsMaxAmount }),
                React.createElement(IdleFee, { title: "IDLE FEES FOR IDLE SESSIONS", detail: "After charger is idle and customer remains plugged in for", disabled: freeMode || !hasPricingWritePermission, minimumGracePeriod: "5", idleFeeEnabled: idleFeesAfterChargingEndsEnabled, idleFeeAmount: idleFeeAfterChargingEnds, idleFeeGracePeriod: idleFeeAfterChargingEndsGracePeriod, idleFeeMaxAmount: idleFeeAfterChargingEndsMaxAmount, helpText: "These fees begin accruing when the customer remains plugged in after the charger stops actively charging the car. Use this to discourage customers from idling at the charger when no useful work is being done.", setIdleFeeAmount: setIdleFeeAfterChargingEnds, setIdleFeeEnabled: setIdleFeesAfterChargingEndsEnabled, setIdleFeeGracePeriod: setIdleFeeAfterChargingEndsGracePeriod, setIdleFeeMaxAmount: setIdleFeeAfterChargingEndsMaxAmount })))),
            tieredPricingEnabled && (React.createElement("div", { className: "flex flex-col gap-y-[32px] ".concat(freeMode ? "opacity-25" : "") },
                React.createElement("label", { className: "font-N6 text-white" }, "Member Pricing"),
                React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                    React.createElement("label", { className: "text-black-400 font-N8p5" }, "ENABLE MEMBER PRICING"),
                    React.createElement(OnOffRadio, { on: memberPricingEnabled, setOn: setMemberPricingEnabled, disabled: freeMode || !hasPricingWritePermission })),
                React.createElement("div", { className: "flex flex-col gap-y-[16px] ".concat(!memberPricingEnabled ? "opacity-25" : "") },
                    React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                        React.createElement("label", { className: "text-black-400 font-N8p5" }, "DEFAULT PRICE FOR MEMBERS"),
                        React.createElement("span", { className: "before:text-black-600 relative before:content-['$'] before:absolute before:pl-[8px] before:translate-y-[-50%] before:top-[50%] after:content-['/kWh'] after:absolute after:translate-y-[-50%] after:top-[50%] after:right-[8px] after:text-black-600" },
                            React.createElement(TextInput, { placeholder: defaultMemberRate, value: defaultMemberRate, required: memberPricingEnabled, type: "number", step: ".01", min: ".01", max: "9.99", pattern: "^\\d+(\\.)\\d{2}$", className: "!pr-[48px]", onChange: function (e) { return setDefaultMemberRate(e.target.value); }, disabled: !memberPricingEnabled ||
                                    freeMode ||
                                    !hasPricingWritePermission }))),
                    React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                        React.createElement("label", { className: "text-black-400 font-N8p5" }, "PRICING BY MEMBER TIER"),
                        tierOverrides.map(function (tier, index) { return (React.createElement(MemberTierRow, { key: index, tierCode: tier.tierCode, rate: tier.rate, disabled: !memberPricingEnabled ||
                                freeMode ||
                                !hasPricingWritePermission, setTierCode: function (tierCode) {
                                return setTierOverrides(function (prev) {
                                    return prev.map(function (t, i) {
                                        return i == index ? __assign(__assign({}, t), { tierCode: tierCode }) : t;
                                    });
                                });
                            }, setRate: function (rate) {
                                return setTierOverrides(function (prev) {
                                    return prev.map(function (t, i) { return (i == index ? __assign(__assign({}, t), { rate: rate }) : t); });
                                });
                            }, onRemove: function () {
                                return setTierOverrides(function (prev) {
                                    return prev.filter(function (_, i) { return i != index; });
                                });
                            } })); }),
                        React.createElement(StyledButton, { text: "+ ADD TIER", onClick: function () {
                                return setTierOverrides(function (prev) { return __spreadArray(__spreadArray([], prev, true), [
                                    { tierCode: "", rate: "0.00" },
                                ], false); });
                            }, disabled: !memberPricingEnabled ||
                                freeMode ||
                                !hasPricingWritePermission }))))),
            React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                React.createElement(TextInput, { type: "text", placeholder: freeMode
                        ? "Reason for pricing change"
                        : "Reason for pricing change (optional)", onChange: function (newText) { return setChangeDescription(newText.target.value); }, required: freeMode, maxLength: 512, value: changeDescription })),
            React.createElement("div", { className: "flex flex-col gap-y-[8px]" },
                React.createElement(StyledButton, { text: "SAVE CHANGES", onClick: validateAndSubmitPricing, disabled: !hasPricingWritePermission }))),
        React.createElement("div", { className: "flex flex-col mt-20" },
            React.createElement(HistoricalPricing, { siteId: details.id, idleFeesAllowed: !isCalifornia, tieredPricingEnabled: tieredPricingEnabled }))));
};
function HistoricalPricing(_a) {
    var siteId = _a.siteId, idleFeesAllowed = _a.idleFeesAllowed, tieredPricingEnabled = _a.tieredPricingEnabled;
    var _b = useAuth0(), isAuthenticated = _b.isAuthenticated, isLoading = _b.isLoading, getAccessTokenSilently = _b.getAccessTokenSilently;
    var requestUrl = "".concat(process.env.CORE_SVC_URL, "/pricing/history/").concat(siteId);
    var historicalPricing = useSWR(isLoading || !isAuthenticated ? null : [requestUrl, getAccessTokenSilently], Auth0Fetcher).data;
    var idleFeeColumns = [
        {
            header: "Idle fees for long sessions",
            wrapHeader: true,
            size: 140,
            accessorFn: function (r) {
                var _a, _b;
                if (r.idleFeesAfterChargingStartsAmount == undefined)
                    return "";
                var amountPerMinute = GetDisplayPrice(r.idleFeesAfterChargingStartsAmount, (_a = r.idleFeesAfterChargingStartsPrecision) !== null && _a !== void 0 ? _a : 2);
                var maxAmount = GetDisplayPrice(r.maxIdleFeeAfterChargingStartsAmount, (_b = r.maxIdleFeeAfterChargingStartsPrecision) !== null && _b !== void 0 ? _b : 2);
                return "$".concat(amountPerMinute, "/minute after ").concat(r.idleFeesAfterChargingStartsGracePeriod, " minutes (max $").concat(maxAmount, ")");
            },
        },
        {
            header: "Idle fees for idle sessions",
            wrapHeader: true,
            size: 140,
            accessorFn: function (r) {
                var _a, _b;
                if (r.idleFeesAfterChargingEndsAmount == undefined)
                    return "";
                var amountPerMinute = GetDisplayPrice(r.idleFeesAfterChargingEndsAmount, (_a = r.idleFeesAfterChargingEndsPrecision) !== null && _a !== void 0 ? _a : 2);
                var maxAmount = GetDisplayPrice(r.maxIdleFeeAfterChargingEndsAmount, (_b = r.maxIdleFeeAfterChargingEndsPrecision) !== null && _b !== void 0 ? _b : 2);
                return "$".concat(amountPerMinute, "/minute after ").concat(r.idleFeesAfterChargingEndsGracePeriod, " minutes (max $").concat(maxAmount, ")");
            },
        },
    ];
    var memberPricingParts = function (r) {
        var _a, _b;
        if (r.pricingModel == undefined)
            return [];
        var update;
        try {
            update = JSON.parse(r.pricingModel);
        }
        catch (_c) {
            return [];
        }
        var membershipPricing = (_a = update.model) === null || _a === void 0 ? void 0 : _a.membershipPricing;
        if (membershipPricing == undefined)
            return [];
        var formatRate = function (tierModel) {
            var _a, _b, _c, _d, _e;
            var amount = (_b = (_a = tierModel === null || tierModel === void 0 ? void 0 : tierModel.pricePerKwh) === null || _a === void 0 ? void 0 : _a.amount) === null || _b === void 0 ? void 0 : _b.amount;
            if (amount == undefined)
                return undefined;
            return "$".concat(GetDisplayPrice(amount, (_e = (_d = (_c = tierModel === null || tierModel === void 0 ? void 0 : tierModel.pricePerKwh) === null || _c === void 0 ? void 0 : _c.amount) === null || _d === void 0 ? void 0 : _d.precision) !== null && _e !== void 0 ? _e : 2), "/kWh");
        };
        var parts = [];
        var defaultRate = formatRate(membershipPricing.defaultMembershipPricingModel);
        if (defaultRate != undefined) {
            parts.push("Default: ".concat(defaultRate));
        }
        for (var _i = 0, _d = Object.entries((_b = membershipPricing.tierPricingModels) !== null && _b !== void 0 ? _b : {}); _i < _d.length; _i++) {
            var _e = _d[_i], tierCode = _e[0], tierModel = _e[1];
            var tierRate = formatRate(tierModel);
            if (tierRate != undefined) {
                parts.push("".concat(tierCode, ": ").concat(tierRate));
            }
        }
        return parts;
    };
    var memberPricingColumn = {
        header: "Member Pricing",
        accessorFn: function (r) { return memberPricingParts(r).join("\n"); },
        cell: function (_a) {
            var getValue = _a.getValue;
            var value = getValue();
            return (React.createElement(React.Fragment, null, value.split("\n").map(function (part, i) {
                return part.length > 0 && (React.createElement(React.Fragment, { key: i },
                    i > 0 && React.createElement("br", null),
                    part));
            })));
        },
    };
    var pricingColumns = __spreadArray(__spreadArray(__spreadArray([
        {
            header: "Date set",
            accessorFn: function (r) { return new Date(r.createdDate).toLocaleString(); },
        },
        {
            header: "Price",
            accessorFn: function (r) {
                var _a;
                if (r.freeMode) {
                    return "Free mode";
                }
                if (r.pricePerKwhAmount != undefined) {
                    return "".concat(GetDisplayPrice(r.pricePerKwhAmount, (_a = r.pricePerKwhPrecision) !== null && _a !== void 0 ? _a : 2, {
                        maximumFractionDigits: 2,
                        useLocaleString: true,
                        localeStringStyle: NumberLocaleStringStyle.Currency,
                    }), "/kWh");
                }
                if (r.pricePerMinute != undefined) {
                    var tiers = JSON.parse(r.pricePerMinute).tiers;
                    if (tiers.length > 0) {
                        // TODO: Display all tiers of per-minute pricing, not just the first.
                        var _b = tiers[0], maxRateKw = _b.maxRateKw, pricePerMinute = _b.pricePerMinute;
                        return "$".concat(pricePerMinute, "/minute up to ").concat(maxRateKw, "kW...");
                    }
                }
                return "";
            },
        },
        {
            header: "Change Description",
            accessorFn: function (r) { return r.changeDescription; },
        }
    ], (idleFeesAllowed ? idleFeeColumns : []), true), (tieredPricingEnabled ? [memberPricingColumn] : []), true), [
        {
            header: "User",
            accessorFn: function (r) { return r.username; },
        },
    ], false);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "font-N6 text-white" }, "Previous Pricing"),
        React.createElement(StaticTable, { data: historicalPricing, columnDefinitions: pricingColumns, emptyMessage: "No previous pricing models were recorded." })));
}
